module.exports = __webpack_public_path__ + "static/media/ketoemagtramina-1.3659af1f.png";